module.exports = __webpack_public_path__ + "static/media/accessible-icon.76b090bb.svg";